<main class="main">
  <mat-dialog-content>
    <h3 *ngIf="title">{{ title }}</h3>

    <ng-container *ngIf="htmlContent; else normalContent">
      <div class="legal-html-content" [innerHTML]="htmlContent"></div>
    </ng-container>

    <ng-template #normalContent>
      <ng-container *ngIf="paragraphs.length > 0; else singleTextBlock">
        <p *ngFor="let paragraph of paragraphs">{{ paragraph }}</p>
      </ng-container>

      <ng-template #singleTextBlock>
        <p>{{ text || ('orderDoubleCheck' | i18next) }}</p>
      </ng-template>
    </ng-template>
  </mat-dialog-content>

  <mat-dialog-actions class="main--btnContainer">
    <button
      *ngIf="!data?.hideCancelButton"
      type="button"
      class="main--btnContainer__btn btn cancel"
      (click)="closeModal()"
    >
      {{
        isI18nKey(cancelText) ? (cancelText | i18next | uppercase) : cancelText
      }}
    </button>

    <button
      type="button"
      class="main--btnContainer__btn btnConfirm btn confirm"
      (click)="submitRequest()"
    >
      {{
        isI18nKey(confirmText)
          ? (confirmText | i18next | uppercase)
          : confirmText
      }}
    </button>
  </mat-dialog-actions>
</main>
